export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-768w.1989f9b2.avif";